import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { selectRefreshLoginState } from '../selectors';
import { LoginResponse } from '@models/swagger';

export const getData = createSelector(selectRefreshLoginState, (state: State) => state.data);

export const getError = createSelector(selectRefreshLoginState, (state: State) => state.error);

export const getLoading = createSelector(selectRefreshLoginState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: LoginResponse | null) => T) =>
  createSelector(selectRefreshLoginState, (state: State) => fn(state.data));
